import React from 'react'
import {
  LoadingText,
  PlayerContainer,
  StyledPlayer
} from './LoadingColors.styles'
import { getImageUrl } from 'utils/assets/Cdn'
import { useTranslation } from 'i18n'

type Props = {
  renderText?: boolean
  text?: string
}

const LoadingColors: React.FC<Props> = ({ renderText = true, text }) => {
  const { t } = useTranslation()
  return (
    <>
      <PlayerContainer>
        <StyledPlayer
          autoplay
          loop
          controls={false}
          src={getImageUrl('avaliacao-leitora/loading.json')}
        ></StyledPlayer>
      </PlayerContainer>
      {renderText && <LoadingText>{text || t('Aguarde')}</LoadingText>}
    </>
  )
}

export default LoadingColors
